import { useMemo } from "react";
import { BaseballTable } from "../../../../components/tables/BaseballTable";
import {
  columnsValueBattingTeam,
  columnsValuePitchingTeam,
  getSituationalBattingTeamColumns,
  getSituationalPitchingTeamColumns,
  getSplitsBattingTeamColumns,
  getSplitsPitchingTeamColumns,
  getBattedBallBattingTeamColumns,
  getBattedBallPitchingTeamColumns,
  getBaserunningTeamColumns,
} from "../../../../config/leaderboards";

const stripRank = (cols) => cols.filter((c) => c.name !== "#");
const unlink = (cols) =>
  cols.map((c) => {
    if (c.name === "Team") return { ...c, cell: undefined };
    return c;
  });

const COLUMN_MAP = {
  value_batting_team: () => unlink(stripRank(columnsValueBattingTeam)),
  value_pitching_team: () => unlink(stripRank(columnsValuePitchingTeam)),
  situational_batting_team: () => unlink(stripRank(getSituationalBattingTeamColumns)),
  situational_pitching_team: () => unlink(stripRank(getSituationalPitchingTeamColumns)),
  splits_batting_team: () => unlink(stripRank(getSplitsBattingTeamColumns)),
  splits_pitching_team: () => unlink(stripRank(getSplitsPitchingTeamColumns)),
  batted_ball_batting_team: () => unlink(stripRank(getBattedBallBattingTeamColumns)),
  batted_ball_pitching_team: () => unlink(stripRank(getBattedBallPitchingTeamColumns)),
  baserunning_team: () => unlink(stripRank(getBaserunningTeamColumns)),
};

export const TeamStatTable = ({ stats, type, teamName }) => {
  const columns = useMemo(() => {
    const getColumns = COLUMN_MAP[type];
    return getColumns ? getColumns() : [];
  }, [type]);

  return (
    <BaseballTable
      data={stats}
      columns={columns}
      filename={`${teamName || "team"}_${type}_stats.csv`}
      noDataComponent={<div className="text-center py-12 text-gray-500">No leaderboard data available</div>}
    />
  );
};
